const faqs = [
  {
    q: '蚂蚁影视是否需要注册才能观看？',
    a: '不需要注册。蚂蚁影视所有电影、电视剧、综艺、动漫资源均支持免注册免费在线观看，打开网站或APP即可立即播放，无需任何账号信息。',
  },
  {
    q: '蚂蚁影视支持哪些设备观看？',
    a: '蚂蚁影视全面支持手机（iOS/Android）、平板、电脑网页端观看。您可以通过官网直接访问，或下载蚂蚁影视APP获得更流畅的移动端追剧体验，数据实时同步。',
  },
  {
    q: '视频画质如何？会不会卡顿或缓冲？',
    a: '蚂蚁影视全线资源默认提供1080P高清画质，采用智能CDN加速技术，确保播放流畅不缓冲。部分热门影片支持4K超清选项，根据您的网络环境自动适配最佳清晰度。',
  },
  {
    q: '资源更新速度怎么样？新上映的电影多久能看？',
    a: '蚂蚁影视拥有专业的资源采集团队，每日实时更新全网最新热播内容。院线新片一般在下映后第一时间上线，热门电视剧实现同步跟播，确保您不错过任何精彩内容。',
  },
  {
    q: '蚂蚁影视APP在哪里下载？安全吗？',
    a: '您可以通过本页面底部"APP下载"区域扫码或点击下载按钮获取蚂蚁影视官方APP。我们承诺APP不含任何恶意插件或广告病毒，所有安装包均通过安全检测，请放心下载使用。',
  },
  {
    q: '遇到播放问题或资源失效怎么办？',
    a: '如遇播放异常或资源失效，您可以通过页面底部"联系我们"区域提交反馈。我们的技术团队通常在2小时内响应处理，确保您的观影体验不受影响。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            关于蚂蚁影视的常见疑问与解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-50 border border-background-300/30 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-foreground-200 font-medium text-sm list-none hover:text-primary-400 transition-colors">
                <h3 className="text-sm font-medium pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200/50 group-open:bg-primary-500/20 transition-colors">
                  <i className="ri-add-line text-xs text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-xs text-primary-400 hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-400 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}